<template>
    <div v-show="focus" :class="styleMain" >
      <el-radio-group v-model="value">
        <el-radio v-for="item in radios" :key="item.id" :label="item.id">{{ item.shortname }}</el-radio>
      </el-radio-group>
      <span>{{ statusName }}</span>
      <el-button icon="el-icon-close" size="mini" @click="$emit('focus', false)"/>
    </div>
</template>

<script>
import { status } from '@/store/model/sport/football/Status'

export default {
  name: 'SportFootballMatchActionStatus',
  props: {
    action: Object,
    focus: Boolean
  },
  computed: {
    value: {
      get () { return this.action.statusId },
      set (data) { this.$store.dispatch('Sport/Football/Match/putAction', { id: this.action.id, statusId: data }) }
    },
    radios () { return status.actions },
    statusName () { return status.action === false ? status.name(this.action.statusId) : '' },

    styleMain () { return ['sportFootballMatchActionStatus', this.action.homeAway] }
  }
}
</script>

<style>
.sportFootballMatchAction .wrapper > div.sportFootballMatchActionStatus {
  align-self:initial
}
.sportFootballMatchActionStatus {
  position:relative;
  grid-column: 3 / 10;
  grid-row: 3;
  background-color: var(--color-background-grey-dark);
  border-radius: 0 0 6px 6px;
  margin:-3px -5px -5px -5px;
  z-index:1002;
  display:flex;
  padding-left:17px;
}
.sportFootballMatchActionStatus > div{
  align-self: center;
  flex:1
}
.sportFootballMatchActionStatus span{
  font-size:10px;
  align-self: center;
}
.sportFootballMatchActionStatus .el-radio{
  width:60px;
  margin-right:10px;
}
.sportFootballMatchActionStatus.home .el-radio__input.is-checked .el-radio__inner{
  background-color: var(--color-team-home);
  border-color:var(--color-team-home)}
.sportFootballMatchActionStatus.home .el-radio__inner:hover{
  border-color: var(--color-team-home);
}
.sportFootballMatchActionStatus.home .el-radio__input.is-checked+.el-radio__label{
  color: var(--color-team-home)
}
.sportFootballMatchActionStatus.away .el-radio__input.is-checked .el-radio__inner{
  background-color: var(--color-team-away);
  border-color:var(--color-team-away)}
.sportFootballMatchActionStatus.away .el-radio__inner:hover{
  border-color: var(--color-team-away);
}
.sportFootballMatchActionStatus.away .el-radio__input.is-checked+.el-radio__label{
  color: var(--color-team-away)
}
.sportFootballMatchActionStatus button,
.sportFootballMatchActionStatus button:hover{
  background-color:transparent;
  border:none;
  color:var(--color-font-black);
  font-weight:bolder;
  justify-self: right;
}
.sportFootballMatchActionStatus.home button:hover{
  color:var(--color-team-home);
}
.sportFootballMatchActionStatus.away button:hover{
  color:var(--color-team-away);
}
</style>
